export const SUBMIT_CAFE_ITEM = "SUBMIT_CAFE_ITEM";
export const SUBMIT_CAFE_ITEM_SUCCESS = "SUBMIT_CAFE_ITEM_SUCCESS";
export const SUBMIT_CAFE_ITEM_ERROR = "SUBMIT_CAFE_ITEM_ERROR";
export const LOAD_CAFE_ITEM = "LOAD_CAFE_ITEM";
export const LOAD_CAFE_ITEM_SUCCESS = "LOAD_CAFE_ITEM_SUCCESS";